// New keys are added on the Rails side, in ApplicationController#config_data.
const appConfig = typeof window !== "undefined" && window.gon ? window.gon.configs : { userLocale: "en" };

const configData = Object.freeze({
    ...appConfig,
    userLocale: appConfig.userLocale || 'en',
});

export const {
    userLocale,
    currentLocale,
    supportedLanguages,
    tenant,
    userId,
    userName,
    userEmail,
    environment,
    testEnv,
    developmentEnv,
    productionEnv,
    userCompaniesList,
    currentCompanyName,
    canViewMembers,
    globalFiltersData,
    mapboxAccessToken,
    userUnits,
    userAvatarThumbUrl,
    timeZone,
    posthogSettings,
    subscriptionExpired,
} = configData;
